"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIgnoredReferenceTranslationIdMatchesReferenceId = void 0;
function isIgnoredReferenceTranslationIdMatchesReferenceId(ignoredReferenceTranslationIdOrPattern, targetId) {
    const ignoreIdSplit = ignoredReferenceTranslationIdOrPattern.split("*");
    // The maximum number of wildcard characters (*) allowed is 1
    if (ignoreIdSplit.length === 2) {
        return (targetId.startsWith(ignoreIdSplit[0]) &&
            targetId.endsWith(ignoreIdSplit[1]));
    }
    // Otherwise, simply compares
    return targetId === ignoredReferenceTranslationIdOrPattern;
}
exports.isIgnoredReferenceTranslationIdMatchesReferenceId = isIgnoredReferenceTranslationIdMatchesReferenceId;
